import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Observable, interval, map, of, startWith, takeWhile } from 'rxjs';
import { IAssets } from 'src/app/models/assets';
import { IIncidents } from 'src/app/models/incident';
import { IProperty } from 'src/app/models/property';
import { IUser } from 'src/app/models/user';
import { Visitor } from 'src/app/models/visitor';

@Component({
  selector: 'app-mobile-table-card',
  templateUrl: './mobile-table-card.component.html',
  styleUrls: ['./mobile-table-card.component.scss'],
})
export class MobileTableCardComponent
  implements AfterContentChecked, AfterViewInit
{
  @Input() set visitorTableData(val: Visitor[]) {
    this.visitorList = val;
  }
  @Input() set incidentTableData(val: IIncidents[]) {
    this.incidentList = val;
  }
  @Input() set assetWallTableData(val: IAssets[]) {
    this.assetList = val;
  }
  @Input() set propertyTableData(val: IProperty[]) {
    this.propertyList = val;
  }
  @Input() set timeSlotsTableData(val: any[]) {
    this.timeSlotsList = val;
  }
  @Input() set userTableData(val: IUser[]) {
    this.userList = val;
  }
  @Input() set incidentTimelineTableData(val: any) {
    this.incidentTimeline = val;
  }
  @Input() set isSecurity(val: boolean) {
    if (val) this.isSecurityLog = val;
    else this.isSecurityLog = false;
  }
  @Input() isShowAction: boolean = true;

  @Input() set tableType(
    val:
      | 'visitor'
      | 'incident'
      | 'assetWall'
      | 'property'
      | 'assets'
      | 'assetDetails'
      | 'timeslots'
      | 'manageUser'
      | 'gateVisitor'
      | 'pendingVisitor'
      | 'incidentTimeline'
      | 'incidentSecurity'
  ) {
    this.tableTypeValue = val;
    this.checkTableType(val);
  }
  @Output() showDetails = new EventEmitter<any>();
  @Output() showPreApprovedAction = new EventEmitter<any>();
  @Output() snoozeIncident = new EventEmitter<any>();
  @Output() visitorAction = new EventEmitter<any>();
  constructor(private cdref: ChangeDetectorRef) {}

  isSecurityLog = false;
  visitorList: Visitor[];
  incidentList: IIncidents[];
  assetList: IAssets[];
  propertyList: IProperty[];
  userList: IUser[];
  timeSlotsList: any[];
  incidentTimeline: any;
  isShowDetails = false;
  expandedDetail = '';
  tableTypeValue = '';
  isIncidentTimeline = false;
  isVisitor = false;
  isIncident = false;
  incidentSecurity = false;
  isAssetWall = false;
  isProperty = false;
  isAssets = false;
  isAssetsDetails = false;
  isTimeSlots = false;
  isManageUser = false;
  isGateVisitor = false;
  isPendingVisitor = false;

  onShowDetails(val: any) {
    this.showDetails.emit(val);
  }
  onAction(val: any) {
    this.showPreApprovedAction.emit(val);
  }
  onSnoozeIncident(val: IIncidents) {
    this.snoozeIncident.emit(val);
  }
  checkTableType(val: any) {
    if (val === 'incident' || val === 'incidentSecurity') {
      this.isIncident = true;
      if (val === 'incidentSecurity') this.incidentSecurity = true;
      this.isVisitor = false;
      this.isAssetWall = false;
      this.isProperty = false;
      this.isAssets = false;
      this.isAssetsDetails = false;
      this.isTimeSlots = false;
    } else if (val === 'visitor') {
      this.isVisitor = true;
      this.isIncident = false;
      this.isAssetWall = false;
      this.isProperty = false;
      this.isAssets = false;
      this.isAssetsDetails = false;
      this.isTimeSlots = false;
    } else if (val === 'assetWall') {
      this.isAssetWall = true;
      this.isVisitor = false;
      this.isIncident = false;
      this.isProperty = false;
      this.isAssets = false;
      this.isAssetsDetails = false;
      this.isTimeSlots = false;
    } else if (val === 'property') {
      this.isAssetWall = false;
      this.isVisitor = false;
      this.isIncident = false;
      this.isProperty = true;
      this.isAssets = false;
      this.isAssetsDetails = false;
      this.isTimeSlots = false;
    } else if (val === 'assets') {
      this.isAssetWall = false;
      this.isVisitor = false;
      this.isIncident = false;
      this.isProperty = false;
      this.isAssets = true;
      this.isAssetsDetails = false;
      this.isTimeSlots = false;
    } else if (val === 'assetDetails') {
      this.isAssetWall = false;
      this.isVisitor = false;
      this.isIncident = false;
      this.isProperty = false;
      this.isAssets = false;
      this.isAssetsDetails = true;
      this.isTimeSlots = false;
    } else if (val === 'timeslots') {
      this.isAssetWall = false;
      this.isVisitor = false;
      this.isIncident = false;
      this.isProperty = false;
      this.isAssets = false;
      this.isAssetsDetails = false;
      this.isTimeSlots = true;
    } else if (val === 'manageUser') {
      this.isAssetWall = false;
      this.isVisitor = false;
      this.isIncident = false;
      this.isProperty = false;
      this.isAssets = false;
      this.isAssetsDetails = false;
      this.isTimeSlots = false;
      this.isManageUser = true;
    } else if (val === 'gateVisitor') {
      this.isGateVisitor = true;
      this.isVisitor = false;
      this.isIncident = false;
      this.isAssetWall = false;
      this.isProperty = false;
      this.isAssets = false;
      this.isAssetsDetails = false;
      this.isTimeSlots = false;
    } else if (val === 'pendingVisitor') {
      this.isPendingVisitor = true;
      this.isVisitor = false;
      this.isIncident = false;
      this.isAssetWall = false;
      this.isProperty = false;
      this.isAssets = false;
      this.isAssetsDetails = false;
      this.isTimeSlots = false;
    } else if (val === 'incidentTimeline') {
      this.isIncidentTimeline = true;
    }
  }
  isOpenApprovalSection(visitor: any): boolean {
    if (visitor && visitor.inviteCreateDate) {
      const currentDate = new Date();
      const inviteCreateDate = new Date(visitor.inviteCreateDate + 'Z');

      const timeDifferenceInMilliseconds =
        currentDate.getTime() - inviteCreateDate.getTime();

      const timeDifferenceInHours =
        timeDifferenceInMilliseconds / (1000 * 60 * 60);

      return timeDifferenceInHours <= 2;
    }
    return false;
  }
  getExpectedCheckoutTimeNumber(row: any): Observable<number> {
    // Assuming row.checkIn is a valid Date object
    const expectedCheckoutTime = new Date(row.checkIn + 'Z');
    expectedCheckoutTime.setMinutes(expectedCheckoutTime.getMinutes() + 30);

    return interval(1000) // Emit a value every second
      .pipe(
        startWith(0), // Emit the initial value immediately
        map(() => {
          const currentTime = new Date();
          const timeDifferenceInMilliseconds =
            expectedCheckoutTime.getTime() - currentTime.getTime();
          const timeDifferenceInSeconds = Math.max(
            Math.floor(timeDifferenceInMilliseconds / 1000),
            0
          );

          const minutes = Math.floor(timeDifferenceInSeconds / 60);
          const seconds = timeDifferenceInSeconds % 60;
          return minutes + seconds / 100; // Display seconds as a decimal part of the minute
        }),
        takeWhile((time) => time > 0, true) // Stop emitting when time is less than 0
      );
  }
  getExpectedCheckoutTime(row: any): Observable<string> {
    // Assuming row.checkIn is a valid Date object
    const expectedCheckoutTime = new Date(row.checkIn + 'Z');
    expectedCheckoutTime.setMinutes(expectedCheckoutTime.getMinutes() + 30);

    const currentTime = new Date();
    const timeDifferenceInMilliseconds =
      expectedCheckoutTime.getTime() - currentTime.getTime();
    const timeDifferenceInSeconds = Math.max(
      Math.floor(timeDifferenceInMilliseconds / 1000),
      0
    );

    const minutes = Math.floor(timeDifferenceInSeconds / 60);
    const seconds = timeDifferenceInSeconds % 60;

    // Format minutes and seconds with leading zeros
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

    // Display seconds as a decimal part of the minute
    const formattedTime = `${formattedMinutes}:${formattedSeconds}`;

    // Return "minute" or "minutes" based on the value of minutes
    const minuteLabel = minutes === 1 ? 'minute' : 'minutes';

    return of(`${formattedTime} ${minuteLabel}`);
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
  ngAfterViewInit(): void {
    this.cdref.detectChanges();
  }
  getAssetlocation(val: any): string {
    if (!val) {
      return '';
    }
  
    try {
      const locationData: any[] = JSON.parse(val);
  
      if (Array.isArray(locationData) && locationData.length > 0 && locationData[0]?.label) {
        return locationData[0].label;
      }
  
      return '';
    } catch (error) {
      // val is not a valid JSON string, return as-is or empty
      return typeof val === 'string' ? val : '';
    }
  }
  getFormatedDate(val: any) {
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
  getCFormatedDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return new Date(date).toLocaleString('en-US', options);
  }
}
